import { createContext, useContext, useEffect, useState } from "react";

const LiveRatingContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const LiveRatingProvider = ({ children }) => {
  const [liveData, setLiveData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/api/reviews`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data && data.live && data.reviews && data.reviews.length) {
          setLiveData(data);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LiveRatingContext.Provider value={liveData}>
      {children}
    </LiveRatingContext.Provider>
  );
};

export const useLiveRating = () => useContext(LiveRatingContext);

export const useRatingFigures = () => {
  const liveData = useLiveRating();
  const isLive = !!(liveData && liveData.reviews && liveData.reviews.length);
  return {
    isLive,
    data: isLive ? liveData : null,
    rating: isLive ? Number(liveData.rating).toFixed(1) : "5.0",
    count: isLive ? liveData.userRatingCount : 80,
  };
};
